import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-0 p-4 pb-0" }
const _hoisted_2 = { class: "col-12 py-3" }
const _hoisted_3 = { class: "col-12 form-group" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "form-group col-12 ps-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "non-standard-items" }, " Non Standard Items", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateDmeNeededRow = _resolveComponent("CreateDmeNeededRow")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "DME Needed",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referral.dmeNeeded, (dmeNeeded, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-12 py-2",
            key: dmeNeeded.id
          }, [
            _createVNode(_component_CreateDmeNeededRow, {
              "dme-needed": dmeNeeded,
              referral: _ctx.referral,
              "dme-index": index
            }, null, 8 /* PROPS */, ["dme-needed", "referral", "dme-index"])
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-md btn-primary px-3",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addEquipment && _ctx.addEquipment(...args)))
            }, "Add Equipment")
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_CommentInput, {
              "input-name": "referral-comments",
              result: _ctx.referral.otherDME,
              classList: _ctx.commentInputClass,
              maxLength: 250,
              "show-template-typeahead": _ctx.showTemplate,
              onResultUpdatedAppended: _ctx.resultUpdatedAppended,
              onResultUpdated: _ctx.resultUpdated
            }, null, 8 /* PROPS */, ["result", "classList", "show-template-typeahead", "onResultUpdatedAppended", "onResultUpdated"])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}